'use client';

import 'BomdisoftComponents/layout/styles.css';
import { type ReactNode } from 'react';

export type PageContentProps = {
  children: ReactNode;
  drawer?: ReactNode;
};

export const PageContent = ({ children, drawer }: PageContentProps) => (
  <div className='bomdisoft-page-content'>
    <div className='bomdisoft-page-content-main'>{children}</div>
    {drawer}
  </div>
);
